import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import axios from 'axios';
import { API } from '../App';
import Navbar from '../components/Navbar';

const CategoriesPage = () => {
  const { t, i18n } = useTranslation();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${API}/categories?locale=${i18n.language}`);
        setCategories(res.data);
      } catch (e) {
        console.error('Failed to fetch categories', e);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, [i18n.language]);

  const categoryImages = {
    cutting: 'https://images.pexels.com/photos/15659458/pexels-photo-15659458.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    color: 'https://images.pexels.com/photos/7388933/pexels-photo-7388933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    styling: 'https://images.pexels.com/photos/14615064/pexels-photo-14615064.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  };

  return (
    <div className="min-h-screen bg-misel-bg">
      <Navbar />
      
      <div className="pt-24 px-8 md:px-16 pb-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="font-roboto font-bold text-3xl md:text-4xl text-white tracking-wide mb-12">
            {t('categories.title')}
          </h1>
          
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[1, 2, 3].map((i) => (
                <div key={i} className="aspect-[3/4] bg-misel-card animate-pulse rounded-sm" />
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {categories.map((category, index) => (
                <motion.div
                  key={category.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <Link
                    to={`/category/${category.slug}`}
                    data-testid={`category-${category.slug}`}
                    className="block aspect-[3/4] relative overflow-hidden rounded-sm group cursor-pointer"
                  >
                    <div 
                      className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                      style={{ 
                        backgroundImage: `url('${category.image_url || categoryImages[category.slug] || categoryImages.cutting}')`
                      }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 card-hover-gradient" />
                    
                    <div className="absolute bottom-0 left-0 right-0 p-8">
                      <h3 className="font-roboto font-bold text-2xl text-white tracking-wide mb-3">
                        {category.title}
                      </h3>
                      <p className="text-gray-400 line-clamp-3 group-hover:text-gray-200 transition-colors">
                        {category.description}
                      </p>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default CategoriesPage;
